export default {"src":"/_next/static/media/LinkedIn_icon_circle.4422a958.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};